import { StaticCanvas } from 'fabric';
import { buildPieceIdIndex, type BindingType, type FieldBinding } from '@doer/frontend-components/creativity-editor';
import type { RoutedFormData } from '../../../types/templates';
import { EFFECTS } from './effects';
import { buildPatches } from './core/patches';
import { consolidate } from './core/consolidate';
import { preMountAllCanvas } from './binders';

const EMPTY_DEFAULTS: RoutedFormData = {};

// Returns true when the editor took the binding into its model; then we don't paint it.
export type ApplyToModel = (pieceId: string, bindingType: BindingType, value: unknown) => boolean;

export async function applyAllBindings(
  canvas: StaticCanvas,
  formData: RoutedFormData,
  fieldBindings: FieldBinding[],
  activeResolutionId?: string,
  defaults: RoutedFormData = EMPTY_DEFAULTS,
  applyToModel?: ApplyToModel
): Promise<void> {
  // Pre-mount runs before patches so the pieceId index sees the right objects.
  await preMountAllCanvas(canvas, fieldBindings, formData, activeResolutionId);

  const index = buildPieceIdIndex(canvas);
  const patches = buildPatches(fieldBindings, formData, defaults, activeResolutionId);

  await Promise.all(
    Array.from(patches, ([pieceId, patch]) => {
      if (applyToModel?.(pieceId, patch.bindingType, patch.value)) return Promise.resolve();
      const obj = index.get(pieceId);
      if (!obj) return Promise.resolve();
      return EFFECTS[patch.bindingType].applyToCanvas(obj, patch.value);
    })
  );

  consolidate(canvas, index);
}
